import * as React from 'react';
import {ChecklistSummary, Rental, RentalItem} from '../api/dtos/dtos';
import RentalForm from './RentalForm';
import RentalItemsEditor from './RentalItemsEditor';
import locales from '../locales';
import ErrorFormItem from '../common/form-items/ErrorFormItem';
import {EditorMode} from '../common/types';

interface RentalDetailsEditorProps {
  mode: EditorMode;
  editable: boolean;
  showChecklist: boolean;
  rental?: Rental;
  checklistSummary?: ChecklistSummary;
  onSendDocuments?: () => void;
  onRentalChange: (rental: Rental) => void;
  onSubmit: () => void;
  onCancel: () => void;
  onChecklistAdd?: (rentalItem: RentalItem) => void;
  onChecklistEdit?: (checklistId: number) => void;
}

interface RentalDetailsEditorState {
  missingRentalItemsErrorVisible: boolean;
}

class RentalDetailsEditor extends React.Component<RentalDetailsEditorProps, RentalDetailsEditorState> {

  public state: RentalDetailsEditorState = {
    missingRentalItemsErrorVisible: false,
  };

  public render(): React.ReactNode {
    const {
      rental,
      editable,
      onRentalChange,
      mode,
      showChecklist,
      checklistSummary
    } = this.props;
    const {missingRentalItemsErrorVisible} = this.state;
    const rentalItems = rental ? rental.rentalItems ? rental.rentalItems : [] : [];

    return (
      <>
        <RentalForm
          mode={mode}
          editable={editable}
          rental={rental}
          onRentalChange={onRentalChange}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
        >
          <RentalItemsEditor
            mode={mode}
            editable={editable}
            rentalItems={rentalItems}
            onRentalItemsChange={this.onRentalItemsChange}
            showChecklist={showChecklist}
            checklistSummary={checklistSummary}
            onChecklistAdd={this.props.onChecklistAdd}
            onChecklistEdit={this.props.onChecklistEdit}
          />

          {missingRentalItemsErrorVisible && <ErrorFormItem message={locales.item_mandatory}/>}

        </RentalForm>
      </>
    );
  }

  private onFormSubmit = () => {
    const {rental, onSubmit} = this.props;
    const rentalItems = rental ? rental.rentalItems ? rental.rentalItems : [] : [];
    if (rentalItems.length === 0) {
      this.setMissingRentalItemsErrorVisible(true);
      return;
    }
    onSubmit();
  };

  private setMissingRentalItemsErrorVisible = (visible: boolean) => {
    this.setState({
      missingRentalItemsErrorVisible: visible,
    })
  };

  private onFormCancel = () => {
    this.props.onCancel();
  };

  private onRentalItemsChange = (rentalItems: RentalItem[]) => {
    this.setState({
      missingRentalItemsErrorVisible: rentalItems.length === 0,
    });
    const {rental, onRentalChange} = this.props;
    onRentalChange({
      ...rental,
      rentalItems: [...rentalItems],
    });
  };

}

export default RentalDetailsEditor;


// WEBPACK FOOTER //
// ./src/rental-details/RentalDetailsEditor.tsx